import React, { useState } from "react";
import excel from "../../../assets/common/excel.svg";
import uploadColored from "../../../assets/common/uploadColored.svg";
import listFailed from "../../../assets/common/listFailed.svg";
import { RespFont, TextWithPic } from "../../common/Style";
import { useDispatch, useSelector } from "react-redux";
import { addMany } from "../../../store/reducers/guestsReducer";
import { toast } from "react-toastify";
import readXlsxFile from "read-excel-file";
import OpacityLoading from "../../common/loader/OpacityLoading";
import { exportToCSV } from "../../common/others/Functions";

const AddExcel = ({ init }) => {
  const { guestsLoading } = useSelector((state) => state.guestsReducer);

  const dispatch = useDispatch();
  const [errors, setErrors] = useState(false);

  const fileSelected = (event) => {
    readXlsxFile(event.target.files[0]).then((rows) => {
      dispatch(addMany({ rows })).then((res) => {
        if (!res.payload?.error) {
          toast.success("הפעולה בוצעה בהצלחה");
          init();
        } else {
          setErrors(res.payload?.error);
          toast.error("ישנן מספר שגיאות, יש להוריד את הקובץ ולפעול בהתאם");
        }
      });
    });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "100%",
        padding: "40px 30px",
        gap: "16px",
      }}
    >
      <a
        onClick={(e) => e.stopPropagation()}
        href="https://secret-mqr-upload.s3.eu-central-1.amazonaws.com/wedding/sys/tav.xlsx"
        style={{ textDecoration: "none", color: "inherit", width: "100%", maxWidth: "280px" }}
        target="_blank"
        rel="noopener noreferrer"
        download
      >
        <div
          style={{
            backgroundColor: "#ffffff",
            border: "1px solid #e8e8e8",
            borderRadius: "10px",
            padding: "24px",
            cursor: "pointer",
            transition: "all 0.2s ease",
            textAlign: "center",
            direction: "rtl",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#f8f9fa";
            e.currentTarget.style.borderColor = "#d8d8d8";
            e.currentTarget.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.12)";
            e.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#ffffff";
            e.currentTarget.style.borderColor = "#e8e8e8";
            e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.08)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <img
            src={excel}
            alt="excel"
            style={{ width: "48px", height: "48px" }}
          />
          <span
            style={{
              fontSize: "15px",
              fontWeight: "400",
              color: "#2c3e50",
              fontFamily: "system-ui, -apple-system, sans-serif",
              letterSpacing: "0.01em",
            }}
          >
            תבנית
          </span>
        </div>
      </a>
      <div onClick={(e) => e.stopPropagation()} style={{ width: "100%", maxWidth: "280px" }}>
        <label htmlFor="file-upload" style={{ cursor: "pointer", display: "block" }}>
          <div
            style={{
              backgroundColor: "#ffffff",
              border: "1px solid #e8e8e8",
              borderRadius: "10px",
              padding: "24px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              textAlign: "center",
              direction: "rtl",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "#f8f9fa";
              e.currentTarget.style.borderColor = "#d8d8d8";
              e.currentTarget.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.12)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "#ffffff";
              e.currentTarget.style.borderColor = "#e8e8e8";
              e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.08)";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <img
              src={uploadColored}
              alt="uploadColored"
              style={{ width: "48px", height: "48px" }}
            />
            <span
              style={{
                fontSize: "15px",
                fontWeight: "400",
                color: "#2c3e50",
                fontFamily: "system-ui, -apple-system, sans-serif",
                letterSpacing: "0.01em",
              }}
            >
              העלאה
            </span>
          </div>
        </label>
        <input
          id="file-upload"
          type="file"
          onChange={fileSelected}
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          style={{ display: "none" }}
        />
      </div>
      {errors && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            exportToCSV(errors, "שגיאות");
          }}
          style={{
            backgroundColor: "#ffffff",
            border: "1px solid #e8e8e8",
            borderRadius: "10px",
            padding: "24px",
            cursor: "pointer",
            transition: "all 0.2s ease",
            textAlign: "center",
            direction: "rtl",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "12px",
            width: "100%",
            maxWidth: "280px",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = "#f8f9fa";
            e.currentTarget.style.borderColor = "#d8d8d8";
            e.currentTarget.style.boxShadow = "0 2px 6px rgba(0, 0, 0, 0.12)";
            e.currentTarget.style.transform = "translateY(-1px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = "#ffffff";
            e.currentTarget.style.borderColor = "#e8e8e8";
            e.currentTarget.style.boxShadow = "0 1px 3px rgba(0, 0, 0, 0.08)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          <img
            src={listFailed}
            alt="listFailed"
            style={{ width: "48px", height: "48px" }}
          />
          <span
            style={{
              fontSize: "15px",
              fontWeight: "400",
              color: "#2c3e50",
              fontFamily: "system-ui, -apple-system, sans-serif",
              letterSpacing: "0.01em",
            }}
          >
            שגיאות
          </span>
        </div>
      )}

      {guestsLoading && <OpacityLoading />}
    </div>
  );
};

export default AddExcel;
